/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_TitleInputs */



/**
* | output |
* | --- |
* | "Event Group Metadata" |
*
* @param {Event_Group_Metadata_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_title = /** @type {((inputs?: Event_Group_Metadata_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Métadonnées du groupe d'événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisgruppen-Metadaten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metadati del gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метаданные группы событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Metadatos del grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループのメタデータ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह मेटाडेटा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Metadados do grupo de eventos")
	return /** @type {LocalizedString} */ ("Event Group Metadata")
});